export default __webpack_public_path__ + "static/media/Shapes_16.2a63dca0.png";